import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { JoinFaculty } from "../components/community-faculty/JoinFaculty";
import { useLoader } from "../context/LoaderContext";
import { fetchJoinAsFacultyDetails } from "../api/JoinAsFacultyApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { IJoinAsFacultyDetailsData } from "../exports/interfaces";
 
const CommunityFacultyPage = () => {
  const { setLoading } = useLoader();
  const [joinAsFacultyDetails, setJoinAsFacultyDetails] = useState<
    IJoinAsFacultyDetailsData[]
  >([]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchJoinAsFacultyDetails()])
      .then(([joinAsFacultyDetailsData]) => {
        setJoinAsFacultyDetails(joinAsFacultyDetailsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="Community" />
      <JoinFaculty joinAsFacultyDetails={joinAsFacultyDetails} />
    </>
  );
};

export default CommunityFacultyPage;
